<template>
  <div id="app">
    <step-transition>
      <component
        :is="currentStep"
        :key="currentStep">
      </component>
    </step-transition>
  </div>
</template>

<script>
import StepTransition from '@shared/components/StepTransition'
import { mapGetters } from 'vuex'

import Intro from './views/Intro'
import scrollHelper from '@shared/utils/scrollHelper'
import PlanningGame from './views/PlanningGame'
import GamePlan1 from './views/GamePlan1'
import GamePlan2 from './views/GamePlan2'
import GamePlan3 from './views/GamePlan3'
import PlanningOutro from './views/PlanningOutro'

export default {
  name: 'App',
  components: {
    StepTransition,
    intro: Intro,
    planningGame: PlanningGame,
    'plan-1': GamePlan1,
    'plan-2': GamePlan2,
    'plan-3': GamePlan3,
    planningOutro: PlanningOutro
  },
  computed: {
    ...mapGetters(['currentStep'])
  },
  mounted () {
    this.$store.dispatch('init')
    scrollHelper.init()
  }
}
</script>

<style lang="scss">
  @import "../shared/styles/globals";
</style>
